/*
 * mod='role'
 * author: nicy
 * time: 2019-02-21
 */

import { smb_fetch, getAgpApiUrl, getAgpAgmsApiUrl, getAgpAgmsApiUrlNew } from '../../../fetch';
import { hasFeatureFlag } from '@/services';

export const getRoleApiUrl = (mod, act) => {
  const result = getAgpApiUrl(mod, act);

  return result;
};

/**
 * 当分配系统角色为代理投放管理员时，需要选择对应服务商账户
 * @return
 */
export const validQQ = (data) => {
  const url = getRoleApiUrl('role', 'valid_qq');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 当分配系统角色为代理投放管理员时，需要选择对应服务商账户
 * @return
 */
export const validWx = (data) => {
  const url = getRoleApiUrl('role', 'valid_wx');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

//
// /**
//  * 当分配系统角色为代理投放管理员时，需要选择对应服务商账户
//  * @return
//  */
// export const getAgencyList = (data) => {
//     const url = getRoleApiUrl('manage','get_agency_list');
//     const params = $.extend(true, {
//         method: 'GET'
//     }, data);
//
//     return smb_fetch(url, params);
// };

/**
 * 获取客户/员工列表
 * @return
 */
export const getPickerData = (data) => {
  const url = getRoleApiUrl('role', 'get_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取微信服务商下的所有的子客
 * @return
 */
export const getUidAndAppidList = (data) => {
  const url = getRoleApiUrl('advertiser', 'get_uid_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};
/**
 * 获取广点通服务商下的所有的子客
 * @return
 */
export const getAppidList = (data) => {
  const url = getRoleApiUrl('operator', 'get_appid_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取运营管理员下的所有员工
 * @return
 */
export const getStaffList = (data) => {
  const url = getRoleApiUrl('operator', 'get_staff_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取运营管理员下的所有员工
 * @return
 */
export const deleteStaff = (data) => {
  const url = getRoleApiUrl('operator', 'delete_basic_operator');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取运营管理员下的所有员工
 * @return
 */
export const deleteEmployee = (data) => {
  const url = getRoleApiUrl('operator', 'delete');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    data,
  );

  return smb_fetch(url, params);
};

/** 获取员工主要岗位 */
export const getPositionConfig = (data) => {
  const url = getAgpAgmsApiUrl('user', 'attr_config');
  const params = $.extend(
    true,
    {
      method: 'get',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 获取员工相关配置信息
 * @return
 */
export const getConfig = (data) => {
  const url = getRoleApiUrl('operator', 'get_config');
  const params = $.extend(
    true,
    {
      method: 'get',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取已经选择的员工
 * @return
 */
export const getBindEmployeeList = (param) => {
  const url = getRoleApiUrl('operator', param.action);
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    { data: param.data },
  );

  return smb_fetch(url, params);
};

/**
 * 获取已经选择的员工
 * @return
 */
export const getStaffExtendInfo = (param) => {
  const url = getRoleApiUrl('operator', param.action);
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    { data: param.data },
  );

  return smb_fetch(url, params);
};
//
// /**
//  * 获取已经选择的员工
//  * @return
//  */
// export const getList = (data) => {
//     const url = getRoleApiUrl('operator','get_operator_list');
//     const params = $.extend(true, {
//         method: 'GET'
//     }, data);
//
//     return smb_fetch(url, params);
// };

/**
 * 获取员工列表
 * @return
 */
export const getList = (data) => {
  const url = getRoleApiUrl('operator', hasFeatureFlag('is_change_get_to_post_enable') ? 'get_new_list' : 'get_list');
  const params = $.extend(
    true,
    {
      method: hasFeatureFlag('is_change_get_to_post_enable') ? 'POST' : 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取已经选择的员工
 * @return
 */
export const createStaff = (data) => {
  const url = getRoleApiUrl('operator', 'store');
  const params = $.extend(
    true,
    {
      method: 'post',
      timeout: 0,
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取登录员工的信息
 * @return
 */

export const getAccountInfo = (data) => {
  const url = getRoleApiUrl('auth', 'get_user');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

// 获取主体维度的代理投放管理员列表
export const getBmAgencyOperatorList = (data) => {
  const url = getRoleApiUrl('operator', hasFeatureFlag('is_change_get_to_post_enable') ? 'get_new_list' : 'get_list');
  const params = $.extend(
    true,
    {
      method: hasFeatureFlag('is_change_get_to_post_enable') ? 'POST' : 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取代理投放管理员
 * @author v_xmdjliu
 * @return
 */
export const getOperatorList = (data) => {
  const url = getRoleApiUrl('operator', hasFeatureFlag('is_change_get_to_post_enable') ? 'get_new_list' : 'get_list');
  const params = $.extend(
    true,
    {
      method: hasFeatureFlag('is_change_get_to_post_enable') ? 'POST' : 'GET',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 同步组织架构
 * @return
 */
export const syncArchitecture = (data) => {
  const url = getRoleApiUrl('operator', 'sync_architecture');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    data,
  );

  return smb_fetch(url, params);
};

// /////////////////////new/////////////

/**
 * 获取员工详情
 * @param user_id
 * @return
 */
export const getOperatorDetail = (data) => {
  const url = getRoleApiUrl('operator', 'get');
  const params = $.extend(
    true,
    {
      method: 'get',
    },
    data,
  );

  return smb_fetch(url, params);
};
/**
 *  获取运营人员的广告主列表
 * @param user_id
 * @return
 */
export const getBindAdvertiserList = (data) => {
  const url = getRoleApiUrl('operator', 'get_bind_advertiser_list');
  const params = $.extend(
    true,
    {
      method: 'get',
    },
    data,
  );

  return smb_fetch(url, params);
};
/**
 * 获取设计师的广告主列表
 * @param user_id
 * @return
 */
export const getDesignerBindAdvertiserList = (data) => {
  const url = getRoleApiUrl('operator', 'get_designer_bind_advertiser_list');
  const params = $.extend(
    true,
    {
      method: 'get',
    },
    data,
  );

  return smb_fetch(url, params);
};
/**
 * 获取广告主的设计师列表
 * @param user_id
 * @return
 */
export const getAdvertiserDesignerList = (data) => {
  const url = getRoleApiUrl('operator', 'get_advertiser_designer_list');
  const params = $.extend(
    true,
    {
      method: 'get',
    },
    data,
  );

  return smb_fetch(url, params);
};
/**
 * 获取员工详情
 * @param user_id
 * @return
 */
export const getBindOperatorList = (data) => {
  const url = getRoleApiUrl('operator', 'get_bind_operator_list');
  const params = $.extend(
    true,
    {
      method: 'get',
    },
    data,
  );

  return smb_fetch(url, params);
};
/**
 * 获取员工详情
 * @param user_id
 * @return
 */
export const checkNumber = (data) => {
  const url = getRoleApiUrl('operator', 'check_number');
  const params = $.extend(
    true,
    {
      method: 'get',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取代理商的广告主列表
 * @param user_id
 * @return
 */
export const getAdvertiserList = (data) => {
  const url = getRoleApiUrl('advertiser', 'get_uid_list');
  const params = $.extend(
    true,
    {
      method: 'get',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取代理商的广告主列表
 * @param user_id
 * @return
 */
export const checkPhone = (data) => {
  const url = getRoleApiUrl('operator', 'check_mobile');
  const params = $.extend(
    true,
    {
      method: 'get',
    },
    data,
  );

  return smb_fetch(url, params);
};
/**
 * 封停员工
 * @param user_id
 * @return
 */
export const operatorFrozen = (data) => {
  const url = getRoleApiUrl('operator', 'frozen');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 跳转营销学堂
 * @param user_id
 * @return
 */
export const jump_edu = (data) => {
  const url = getRoleApiUrl('edu', 'get_config');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 解封员工
 * @param user_id
 * @returnU
 */
export const operatorUnfrozen = (data) => {
  const url = getRoleApiUrl('operator', 'unfrozen');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取是否是团队或者个人
 * @return
 */

export const getOperatorPerson = (data) => {
  const url = getRoleApiUrl('task', 'get_operator_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取营销服务市场应用列表
 * @return
 */
export const getIsvAgencyClients = (data, isShowError = false) => {
  const url = getAgpApiUrl('isv', 'user_client_bind/list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

export default {
  deleteEmployee,
  getAdvertiserList,
  checkNumber,
  getBindOperatorList,
  getBindAdvertiserList,
  getOperatorDetail,
  validQQ,
  validWx,
  getPickerData,
  getStaffList,
  getUidAndAppidList,
  getAppidList,
  deleteStaff,
  getBindEmployeeList,
  getList,
  createStaff,
  getAccountInfo,
  getBmAgencyOperatorList,
  syncArchitecture,
  getOperatorList,
  checkPhone,
  jump_edu,
  operatorFrozen,
  operatorUnfrozen,
  getConfig,
  getDesignerBindAdvertiserList,
  getAdvertiserDesignerList,
  getOperatorPerson,
  getIsvAgencyClients,
  getPositionConfig,
};
